"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonColorCssVariables = void 0;
/**
 * Common var() wrapped CSS variables representing colors used in Aurora.
 */
var CommonColorCssVariables;
(function (CommonColorCssVariables) {
    // lia-color-transparent
    CommonColorCssVariables["TRANSPARENT"] = "transparent";
    CommonColorCssVariables["PRIMARY"] = "var(--lia-bs-primary)";
    // custom-6
    CommonColorCssVariables["BODY_TEXT"] = "var(--lia-bs-body-color)";
    // custom-3
    CommonColorCssVariables["BODY_BG"] = "var(--lia-bs-body-bg)";
    // custom-2
    CommonColorCssVariables["BLACK"] = "var(--lia-bs-black)";
    // custom-6
    CommonColorCssVariables["GRAY_900"] = "var(--lia-bs-gray-900)";
    // custom-4
    CommonColorCssVariables["GRAY_800"] = "var(--lia-bs-gray-800)";
    CommonColorCssVariables["GRAY_700"] = "var(--lia-bs-gray-700)";
    CommonColorCssVariables["GRAY_600"] = "var(--lia-bs-gray-600)";
    CommonColorCssVariables["GRAY_500"] = "var(--lia-bs-gray-500)";
    // custom-5
    CommonColorCssVariables["GRAY_400"] = "var(--lia-bs-gray-400)";
    CommonColorCssVariables["GRAY_300"] = "var(--lia-bs-gray-300)";
    // custom-3
    CommonColorCssVariables["GRAY_200"] = "var(--lia-bs-gray-200)";
    // custom-1
    CommonColorCssVariables["WHITE"] = "var(--lia-bs-white)";
    CommonColorCssVariables["DANGER"] = "var(--lia-bs-danger)";
})(CommonColorCssVariables || (exports.CommonColorCssVariables = CommonColorCssVariables = {}));
//# sourceMappingURL=index.js.map